import React, { useState, useRef, useEffect } from 'react';
import {
  Card,
  Button,
} from 'react-bootstrap';
import ProjectCardThumb from '../../../../../assets/img/project-covers/card_project.png';
import {
  FaRegStar,
  FaStar,
  FaRegTrashAlt,
  FaEllipsisV,
  FaExternalLinkAlt,
  FaExclamationCircle,
  FaEllipsisH,
  FaRegHourglass 
} from 'react-icons/fa';

import './styles.css';

export default function CardProject({
  title,
  label,
  clientName,
  thumbnail,
  isFavorite,
  accessFunction,
  favoriteFunction,
  deleteFunction,
  view = 'card',
  ...props
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [listMenuPosition, setListMenuPosition] = useState({ top: 0, left: 0 });
  const [favoriteActionLoading, setFavoriteActionLoading] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const listMenuRef = useRef(null);
  const listButtonRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      const currentRef = view !== 'card' ? listMenuRef.current : menuRef.current;
      const currentButton = view !== 'card' ? listButtonRef.current : buttonRef.current;
     
      if (
        currentRef &&
        !currentRef.contains(event.target) &&
        currentButton &&
        !currentButton.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    }

    if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
    else document.removeEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen, view]);

  const currentThumb = ProjectCardThumb;

  if (view !== 'card') {
    return (
      <>
        <div
          className="project-card-list"
          onClick={(event) => {
            event.stopPropagation(event);
            accessFunction?.();
        }}>
          <div className='row'>
            <div className='col-4 d-flex gap-2 align-items-center'>
              <img src={currentThumb} alt={title} className="project-image-list" />
              <span className="project-name-list">{title}</span>
            </div>

            <div className='col-4 d-flex align-items-center'>
              <span className="project-time-list">{label}</span>
            </div>

            <div className='col-4 d-flex justify-content-end'>
              <div className="project-actions-list">
                <span className="project-client-list">{clientName}</span>
                <button 
                  id="list-menu-button"
                  ref={listButtonRef}
                  className="btn"
                  onClick={(event) => {
                    event.stopPropagation();

                    if (listButtonRef.current) {
                      const rect = listButtonRef.current.getBoundingClientRect();
                      setListMenuPosition({
                        top: rect.bottom + 8,
                        left: rect.left
                      });
                    }
                    setMenuOpen((open) => !open)
                  }}
                >
                  <FaEllipsisH className="icon-list" />
                </button>

                <button
                  className='btn'
                  onClick={async (event) => {
                    setFavoriteActionLoading(true);
                    event.stopPropagation();
                    setMenuOpen((open) => !open);
                    try {
                      await favoriteFunction?.();
                    } finally {
                      setFavoriteActionLoading(false);
                    }
                  }}
                >
                  {favoriteActionLoading ? (
                    <FaRegHourglass color='gray' />
                  ) : (
                    isFavorite ? (
                      <FaStar color='black' className="text-warning" />
                    ) : (
                      <FaRegStar color='gray' />
                    )
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {menuOpen && (
          <div
            ref={listMenuRef}
            className="custom-menu bg-dark text-white shadow rounded position-absolute"
            style={{
              zIndex: 10,
              left: listMenuPosition.left,
              top: listMenuPosition.top,
              minWidth: '10rem',
              position: 'fixed',
            }}
          >
            <div
              className="d-flex align-items-center gap-1 px-3 py-2 menu-item"
              style={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.stopPropagation();
                setMenuOpen(false);
                accessFunction?.();
              }}
            >
              <FaExternalLinkAlt  fontSize="small" /> Acessar
            </div>

            <div
              className="d-flex align-items-center gap-1 px-3 py-2 menu-item"
              style={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.stopPropagation();
                setMenuOpen(false);
                favoriteFunction?.();
              }}
            >
              <FaRegStar fontSize="small" /> {isFavorite ? 'Remover dos favoritos' : 'Favoritar'}
            </div>

            <div className="dropdown-divider my-1" style={{ borderTop: '1px solid #444' }} />

            <div
              className="d-flex align-items-center gap-1 px-3 py-2 menu-item text-danger"
              style={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.stopPropagation();
                setMenuOpen(false);
                setShowDeleteModal(true);
              }}
            >
              <FaRegTrashAlt fontSize="small" /> Apagar
            </div>
          </div>
        )}

        {showDeleteModal && (
          <div className="modal-overlay" id="delete-modal">
            <div className="modal-container">
              <button className="modal-close" onClick={() => setShowDeleteModal(false)}>×</button>

              <div className="modal-icon">
                <FaExclamationCircle  size={32} color="#FFD400" />
              </div>

              <h2 className="modal-title">Apagar Projeto?</h2>
              <p className="modal-description mb-3">
                Deseja realmente enviar <span className="modal-project"><strong>{title}</strong></span> para lixeira? Após 90 dias ele será deletado definitivamente.
              </p>

              <div className="modal-actions">
                <button className="btn-cancel" onClick={() => setShowDeleteModal(false)}>Cancelar</button>
                <button className="btn-delete" onClick={() => {
                  setShowDeleteModal(false);
                  deleteFunction?.();
                }}>
                  <FaRegTrashAlt className="btn-delete-icon" />
                  Apagar
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <Card className="project-card bg-dark text-white shadow" {...props}>
        <Card.Img variant="top" src={currentThumb} />

        <div className="overlay" onClick={() => accessFunction?.()}>
          <span className="client-tag">{clientName}</span>

          <div className="d-flex gap-2 overlay-buttons">
            <button
              ref={buttonRef}
              type="button"
              className="menu-toggle-btn p-0 text-white d-flex flex-row justify-content-center align-items-center"
              style={{ background: 'none', border: 'none', outline: 'none', boxShadow: 'none' }}
              onClick={(event) => {
                event.stopPropagation();
                setMenuOpen((open) => !open)
              }}
            >
              <FaEllipsisV color='black' />
            </button>
            
            {menuOpen && (
              <div
                ref={menuRef}
                className="custom-menu bg-dark text-white shadow rounded position-absolute"
                style={{ zIndex: 10, right: 0, top: '2.5rem', minWidth: '10rem' }}
              >
                <div
                  className="d-flex align-items-center gap-1 px-3 py-2 menu-item"
                  style={{ cursor: 'pointer' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    setMenuOpen(false);
                    accessFunction?.();
                  }}
                >
                  <FaExternalLinkAlt  fontSize="small" /> Acessar
                </div>

                <div
                  className="d-flex align-items-center gap-1 px-3 py-2 menu-item"
                  style={{ cursor: 'pointer' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    setMenuOpen(false);
                    favoriteFunction?.();
                  }}
                >
                  <FaRegStar fontSize="small" /> {isFavorite ? "Remover dos favoritos" : "Favoritar"}
                </div>

                <div className="dropdown-divider my-1" style={{ borderTop: '1px solid #444' }} />

                <div
                  className="d-flex align-items-center gap-1 px-3 py-2 menu-item text-danger"
                  style={{ cursor: 'pointer' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    setMenuOpen(false);
                    setShowDeleteModal(true);
                  }}
                >
                  <FaRegTrashAlt fontSize="small" /> Apagar
                </div>
              </div>
            )}

            <Button
              variant="link"
              className="p-0 text-white"
              onClick={async (event) => {
                setFavoriteActionLoading(true);
                event.stopPropagation();
                try {
                  await favoriteFunction?.();
                } finally {
                  setFavoriteActionLoading(false);
                }
              }}
            >
              {favoriteActionLoading ? (
                <FaRegHourglass color='gray' />
              ) : (
                isFavorite ? (
                  <FaStar color='black' className="text-warning" />
                ) : (
                  <FaRegStar color='gray' />
                )
              )}
            </Button>
          </div>
        </div>

        <Card.Body className="card-body">
          <Card.Title className="card-body-title">{title}</Card.Title>
          <Card.Text className="card-body-label">{label}</Card.Text>
        </Card.Body>
      </Card>

      {showDeleteModal && (
        <div className="modal-overlay" id="delete-modal">
          <div className="modal-container">
            <button className="modal-close" onClick={() => setShowDeleteModal(false)}>×</button>

            <div className="modal-icon">
              <FaExclamationCircle  size={32} color="#FFD400" />
            </div>

            <h2 className="modal-title">Apagar Projeto?</h2>
            <p className="modal-description mb-3">
              Deseja realmente enviar <span className="modal-project"><strong>{title}</strong></span> para lixeira? Após 90 dias ele será deletado definitivamente.
            </p>

            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setShowDeleteModal(false)}>Cancelar</button>
              <button className="btn-delete" onClick={() => {
                setShowDeleteModal(false);
                deleteFunction?.();
              }}>
                <FaRegTrashAlt className="btn-delete-icon" />
                Apagar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}